
    const data = {"name":"src/core/icons/view-column-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 5v13h17V5H4m10 2v9h-3V7h3M6 7h3v9H6V7m13 9h-3V7h3v9Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            